// moment-config.js
import Vue from 'vue'
import moment from 'moment-timezone'
Vue.prototype.$defaultTimezone = 'Europe/Berlin'
moment.tz.setDefault(Vue.prototype.$defaultTimezone)
moment.locale('de-DE')
export default moment
